import config from "environment";
import { getRequest, postRequest, uploadClient } from "./client";
import { CompanyDocument } from "winslow-core";

const { baseApi } = config;

export async function apiGetCompanyDocumentsForWorkspace(
  workspaceId: string
): Promise<CompanyDocument[] | null> {
  const fetchURL = `${baseApi}/company-documents/workspace/${workspaceId}`;
  return await getRequest(fetchURL, "API/apiGetCompanyDocumentsByWorkspace");
}

export async function apiGetCompanyDocument(
  companyDocumentId: string
): Promise<CompanyDocument[] | null> {
  const fetchURL = `${baseApi}/company-documents/workspace/${companyDocumentId}`;
  return await getRequest(fetchURL, "API/apiGetCompanyDocument");
}

export async function apiCreateCompanyDocument(
  payload: Partial<CompanyDocument>
): Promise<CompanyDocument | null> {
  const fetchURL = `${baseApi}/company-documents/create`;
  return await postRequest(fetchURL, payload, "API/apiCreateCompanyDocument");
}

export const apiUploadCompanyDocumentsForWorkspace = async (
  workspaceId: string,
  payload: any,
  file: File
) => {
  const formData = new FormData();

  console.log("[apiUploadCompanyDocumentsForWorkspace] payload: ", payload);
  for (const key in payload) {
    if (payload.hasOwnProperty(key)) {
      console.log("[apiUploadCompanyDocumentsForWorkspace] key: ", key);
      formData.append(key, payload[key]);
    }
  }

  formData.append("file", file);

  console.log("[apiUploadCompanyDocumentsForWorkspace] file: ", file);
  console.log(
    "[apiUploadCompanyDocumentsForWorkspace] formData: ",
    Array.from(formData.keys())
  );

  return await uploadClient.post(
    `${baseApi}/company-documents/upload/workspace/${workspaceId}`,
    formData
  );
};

export async function apiUpdateCompanyDocument(
  payload: Partial<CompanyDocument>
): Promise<CompanyDocument | null> {
  const fetchURL = `${baseApi}/company-documents/update`;
  return await postRequest(fetchURL, payload, "API/apiUpdateCompanyDocument");
}

export async function apiDeleteCompanyDocument(
  companyDocumentId: string
): Promise<CompanyDocument | null> {
  const fetchURL = `${baseApi}/company-documents/delete/${companyDocumentId}`;
  return await getRequest(fetchURL, "API/apiDeleteCompanyDocument");
}
